import { render, staticRenderFns } from "./importResultDialog.vue?vue&type=template&id=2bbde0e2&scoped=true&"
import script from "./importResultDialog.vue?vue&type=script&lang=js&"
export * from "./importResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./importResultDialog.vue?vue&type=style&index=0&id=2bbde0e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbde0e2",
  null
  
)

export default component.exports